import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestParaquatLawyersWrapper from "@components/layouts/bestparaquatlawyersWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function BestParaquatLawyersHome(): ReactElement {
    return (
        <BestParaquatLawyersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="Paraquat"
                    domain="BestParaquatLawyers.com"
                />
            </div>
        </BestParaquatLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
